<template>
  <Card class="card" dis-hover shadow>
    <!--基本信息-->
    <div class="info-wrapper">
      <div class="mar-btm30 title">
        <span class="text1">基本信息</span>
      </div>
      <div class="info">
        <Form :label-width="100" ref="form" label-colon label-position="left" :show-message="false">
          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <!--企业头像-->
              <div class="mar-btm30 box">
                <div class="left">企业头像</div>
                <div
                  class="head-pic-wrapper yuan"
                  @mouseenter="showCamera = true"
                  @mouseleave="showCamera = false"
                  @click="addHeadpic"
                >
                  <input
                    type="file"
                    id="uploads"
                    class="upload-btn"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                    @change="uploadImg"
                    hidden
                  />
                  <img
                    v-if="qiye.headPic && qiye.headPic[0].path"
                    class="yuan"
                    :src="qiye.headPic[0].path"
                  />
                  <div v-else class="yuan logo">LOGO</div>
                  <div v-if="showCamera" class="yuan head-pic-icon iconfont icon-xiangji"></div>
                </div>
              </div>
            </Col>
            <!-- <Col span="8">
              所属社区
              <div class="mar-btm30 box" v-if="$store.state.isJiedao == 1">
                <div class="left">所属社区</div>
                <Select v-model="modelSelect" class="input" @on-change="selectCommunity">
                  <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </div>
            </Col>-->
            <Col span="8">
              <!--企业名称-->
              <FormItem label="企业名称" prop="name">
                <Input v-model="qiye.name" size="large" placeholder="请输入您的企业名称" class="input" />
              </FormItem>
            </Col>
          </Row>

          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <FormItem label="企业别名" prop="alias">
                <Input v-model="qiye.alias" size="large" placeholder="请输入别名" class="input" />
              </FormItem>
            </Col>
            <Col span="8" prop="zhuceNum">
              <FormItem label="统一社会信用代码" prop="zhuceNum">
                <Input v-model="qiye.zhuceNum" size="large" placeholder="请输入统一社会信用代码" class="input" />
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="行业类别" prop="tradeId" >
                <Select v-model="qiye.tradeId" class="input">
                  <Option
                    v-for="item in IndustryType"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <FormItem label="所在分局" prop="deptId" >
                <Select v-model="qiye.deptId" class="input">
                  <Option v-for="item in depType" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="服务类型">
                <Select v-model="serviceIdList" class="input" multiple>
                  <Option
                    v-for="item in serviceType"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <FormItem label="经营地址">
                <div class="input box">
                  <div
                    v-if="didian"
                    class="address slh"
                    :title="didian"
                    @click="showmap()"
                  >{{ didian }}</div>
                  <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
                  <map-modal
                    v-if="showMap"
                    @confirm="getAddress"
                    @cancel="showmap"
                    :zuobiao="zuobiao"
                  ></map-modal>
                </div>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="经营范围" prop="businessScope">
                <Input
                  v-model="qiye.businessScope"
                  size="large"
                  placeholder="请输入经营范围"
                  class="input"
                />
              </FormItem>
            </Col>
          </Row>

          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <FormItem label="企业法人" prop="farenName">
                <Input
                  v-model="qiye.farenName"
                  size="large"
                  placeholder="请输入您的法人姓名"
                  style="margin-right: 20px"
                />
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="法人电话" prop="farenTel">
                <Input v-model="qiye.farenTel" size="large" placeholder="请输入您的法人电话" />
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="企业负责人" prop="zerenName">
                <Input
                  v-model="qiye.zerenName"
                  size="large"
                  placeholder="请输入您的负责人姓名"
                  style="margin-right: 20px"
                />
              </FormItem>
            </Col>
          </Row>
          <Row class="row-wrap" :gutter="80">
            <Col span="8">
              <FormItem label="企业负责人电话" prop="zerenTel" >
                <Input v-model="qiye.zerenTel" size="large" placeholder="请输入您的负责人电话" />
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="职工人数" prop="employeeNum" >
                <Input v-model="qiye.employeeNum" size="large" placeholder="请输入职工人数" class="input" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>

    <!--详细信息-->
    <div>
      <div class="mar-btm30 title">
        <span class="text1">企业详细信息</span>
      </div>
      <div class="info">
        <Row class="row-wrap" :gutter="80">
          <Col span="8">
            <!--企业经营面积-->
            <div class="mar-btm30 box">
              <div class="left">经营面积</div>
              <div class="box input" style="align-items: center">
                <Input v-model="qiye.area" size="large" placeholder="请输入经营面积" class="box_f1" />
                <div class="text2">平方米</div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <!--经营时间-->
            <div class="mar-btm30 box">
              <div class="left" style="align-self:flex-start ">经营时间</div>
              <div class="box_f1">
                <div class="box time-wrapper" v-for="(item, index) in qiye.timeList" :key="index">
                  <TimePicker
                    type="time"
                    placeholder="请选择时间"
                    v-model="item.beginTime"
                    class="box_f1"
                  ></TimePicker>
                  <div class="text4">至</div>
                  <TimePicker type="time" placeholder="请选择时间" v-model="item.endTime" class="box_f1"></TimePicker>
                  <!--删除按钮-->
                  <div class="iconfont icon-quxiao1 del-icon" @click="delTime(index)"></div>
                </div>
                <div class="addBtn box" @click="addTime">
                  <div class="iconfont icon-tianjia"></div>
                  <div>添加</div>
                </div>
              </div>
            </div>
          </Col>
          <Col span="8">
            <!--是否可派送-->
            <div class="mar-btm30 box">
              <div class="left">是否有送货服务</div>
              <RadioGroup v-model="qiye.paisong">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </div>
          </Col>
        </Row>

        <Row class="row-wrap" :gutter="80">
          <Col span="12">
            <!--是否可派送-->
            <div v-if="qiye.paisong == '是'" class="mar-btm30 box">
              <div class="left" style="align-self:flex-start ">派送时间</div>
              <div class="box_f1">
                <div
                  class="box time-wrapper"
                  v-for="(item, index) in qiye.paisongTime"
                  :key="index"
                >
                  <TimePicker
                    type="time"
                    placeholder="请选择时间"
                    v-model="item.beginTime"
                    class="box_f1"
                  ></TimePicker>
                  <div class="text4">至</div>
                  <TimePicker type="time" placeholder="请选择时间" v-model="item.endTime" class="box_f1"></TimePicker>
                  <!--删除按钮-->
                  <div class="iconfont icon-quxiao1 del-icon" @click="delPaisongTime(index)"></div>
                </div>
                <div class="addBtn box" @click="addPaisongTime">
                  <div class="iconfont icon-tianjia"></div>
                  <div>添加</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row class="row-wrap" :gutter="80">
          <Col span="8">
            <!--企业类型-->
            <div class="mar-btm30 box">
              <div class="left">企业类型</div>
              <RadioGroup v-model="qiye.companyType">
                <Radio label="企业"></Radio>
                <Radio label="个体"></Radio>
              </RadioGroup>
            </div>
          </Col>
          <Col span="8">
            <!--企业性质-->
            <div class="mar-btm30 box">
              <div class="left">企业性质</div>
              <Select v-model="xingzhi" class="input">
                <Option v-for="item in qiyeXingzhi" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </div>
          </Col>
          <Col span="8">
            <!--企业属性-->
            <div class="mar-btm30 box">
              <div class="left">企业属性</div>
              <CheckboxGroup v-model="selectRadio">
                <Checkbox
                  v-for="(item, index) in qyNature"
                  :key="index"
                  :label="item.id"
                  class="checkbox-item"
                >{{ item.name }}</Checkbox>
              </CheckboxGroup>
            </div>
          </Col>
        </Row>

        <Row class="row-wrap" :gutter="80">
          <Col span="8">
            <!--企业图片-->
            <div class="mar-btm30">
              <div class="box imglist">
                <div class="left">
                  <span>企业图片</span>
                </div>
                <upl-img-act
                  :multiple="true"
                  :imgArr="imgArr"
                  :imgNumber="imgNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  :isClick="isClick"
                  :isClickE="isClickE"
                  @saveImg="saveImg"
                  @delPic="delPic"
                  class="upload-img"
                >
                  <div class="uploadbox">
                    <div class="iconfont icon-shangchuan1 img_add"></div>
                  </div>
                </upl-img-act>
              </div>
              <div class="text3">（最多上传{{ imgNumber }}张）</div>
            </div>
          </Col>
          <Col span="8">
            <!--营业执照-->
            <div class="mar-btm30">
              <div class="box imglist">
                <div class="left">
                  <span class="require">*</span>
                  <span>营业执照</span>
                </div>
                <upl-img-act
                  :multiple="true"
                  :imgArr="imgArrlicense"
                  :imgNumber="imgNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveLicenseImg"
                  @delPic="delLicenseImg"
                  class="upload-img"
                >
                  <div class="uploadbox">
                    <div class="iconfont icon-shangchuan1 img_add"></div>
                  </div>
                </upl-img-act>
              </div>
              <div class="text3">（最多上传{{ imgNumber }}张）</div>
            </div>
          </Col>
          <Col span="8">
            <!--各类许可证明-->
            <div class="mar-btm30">
              <div class="box imglist">
                <div class="left">
                  <span>各类许可证明(类似食品许可证等)</span>
                </div>
                <upl-img-act
                  :imgArr="imgArrAllkind"
                  :imgNumber="imgNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveAllkindImg"
                  @delPic="delAllkindImg"
                  class
                >
                  <div class="uploadbox">
                    <div class="iconfont icon-shangchuan1 img_add"></div>
                    <!-- <p>上传图片</p> -->
                  </div>
                </upl-img-act>
              </div>
              <div class="text3">（最多上传{{ imgNumber }}张）</div>
            </div>
          </Col>
        </Row>
        <!-- <Row class="row-wrap" :gutter="80">
          <Col span="8">
            承诺书
            <div class="mar-btm30">
              <div class="box imglist">
                <div class="left">
                  <span>承诺书</span>
                </div>
                <upl-img-act
                  :imgArr="imgArrPromise"
                  :imgNumber="imgNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="savePromiseImg"
                  @delPic="delPromiseImg"
                  class
                >
                  <div class="uploadbox">
                    <div class="iconfont icon-shangchuan1 img_add"></div>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </div>
              <div class="text3">（最多上传{{ imgNumber }}张）</div>
            </div>
          </Col>
          <Col span="8">
            健康证明
            <div class="mar-btm30">
              <div class="box imglist">
                <div class="left">
                  <span>健康证明</span>
                </div>
                <upl-img-act
                  :imgArr="imgArrHealthy"
                  :imgNumber="imgNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveHealthyImg"
                  @delPic="delHealthyImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <div class="iconfont icon-shangchuan1 img_add"></div>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </div>
              <div class="text3">（最多上传{{ imgNumber }}张）</div>
            </div>
          </Col>
        </Row>-->
        <!-- <Row class="row-wrap" :gutter="80">
          <Col span="16">
            企业简介
            <div class="pad-btm30 box">
              <div class="left">企业简介</div>
              <editor-box
                class="input"
                :show-footer="false"
                :content-hight="425"
                @editorContent="editorContent"
                :content="qiye.jianjie"
                :showImg="showImg"
              ></editor-box>
            </div>
          </Col>
        </Row>-->
      </div>
    </div>
  </Card>
</template>

<script>
// import addLabel from './addLabel'
import uploadImg from "@/components/uploadImg";
import uplImgAct from "@/components/uplImgAct";
import editorBox from "../../../components/editorBox";
import mapModal from "../../../components/mapModal";
var that;
var map = null; // 地图对象
var mark = null; // 地图标点对象
var autoComplete = null; // 自动搜索填充对象
var geocoder = "";
export default {
  props: {
    bianjiLoading: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: null,
      default: 0
    },
    childShequ: {
      type: Array,
      default: []
    },
    oldQiye: {
      type: Object,
      default: {}
    },
    communityId: {
      type: String,
      default: ""
    }
  },
  components: {
    uploadImg,
    editorBox,
    mapModal,
    uplImgAct
    // addLabel
  },
  watch: {
    bianjiLoading(newValue, oldValue) {
      if (this.bianjiLoading) {
        this.submit();
      }
    }
  },
  data() {
    return {
      rules: {
        // name: [
        //   {
        //     required: true,
        //     message: "请输入企业名称"
        //   }
        // ],
        // zhuceNum: [
        //   {
        //     required: true,
        //     message: "请输入统一社会信用代码"
        //   }
        // ],
        // tradeId: [
        //   {
        //     required: true,
        //     message: "请选择行业类别",
        //     trigger: "change"
        //   }
        // ],
        // deptId: [
        //   {
        //     required: true,
        //     message: "请选择所在分局"
        //   }
        // ],
        // businessScope: [
        //   {
        //     required: true,
        //     message: "请输入经营范围"
        //   }
        // ],
        // farenName: [
        //   {
        //     required: true,
        //     message: "请输入企业法人"
        //   }
        // ],
        // farenTel: [
        //   {
        //     required: true,
        //     message: "请输入法人电话"
        //   }
        // ],
        // zerenName: [
        //   {
        //     required: true,
        //     message: "请输入企业负责人"
        //   }
        // ],
        // zerenTel: [
        //   {
        //     required: true,
        //     message: "请输入负责人电话"
        //   }
        // ],
        // employeeNum: [
        //   {
        //     required: true,
        //     message: "请输入职工人数"
        //   }
        // ]
      },
      showImg: false,
      showAddModel: false,
      modelSelect: "", //选择的行政区域的id
      isActive: true,
      imgArr: [],
      imgArrPromise: [],
      imgArrAllkind: [],
      imgArrHealthy: [],
      imgArrlicense: [],
      imgNumber: 6,
      showCamera: false,
      isClick: 0, // 上传图片的事件触发标志
      isClickE: null, // 上传图片事件的触发对象 event
      qiye: {
        name: "",
        qyNature: []
      },
      didian: "",
      zuobiao: {
        value: "",
        label: ""
      },
      str: "",
      moren: "",
      selectType: [], //选择的类型id集合
      selectRadio: [],
      clickUpload: "",
      showMap: false,
      serviceIdList: [], //选择的服务类型id集合
      xingzhi: "",
      addressList: [], // 联想搜索 地址列表
      mapComplete: false,
      qyType: [], //企业类型的集合（所有的）
      IndustryType: [], //行业类型
      depType: [], //所在分局
      serviceType: [], //服务类型
      qyNature: [], //企业属性集合（所有）
      qiyeXingzhi: [] //企业性质
    };
  },
  computed: {
    changeColor() {
      return function(item, type) {
        if (type == "border") {
          return item.isSelect ? "#ff7b44" : "#dedede";
        }
        if (type == "text") {
          return item.isSelect ? "#ff7b44" : "#999";
        }
      };
    }
  },
  methods: {
    saveImg(data) {
      console.log(data);
      if (this.clickUpload == "head") {
        this.qiye.headPic = [data];
        this.clickUpload = "";
      } else if (this.clickUpload == "zhizhao") {
        this.qiye.zhizhao = [data];
        this.clickUpload = "";
      } else {
        this.imgArr.push(data);
      }
    },
    savePromiseImg(value) {
      this.imgArrPromise.push(value);
    },
    delPromiseImg(delPic) {
      this.imgArrPromise.splice(delPic.index, 1);
    },
    saveHealthyImg(value) {
      this.imgArrHealthy.push(value);
    },
    delHealthyImg(delPic) {
      this.imgArrHealthy.splice(delPic.index, 1);
    },
    saveAllkindImg(value) {
      this.imgArrAllkind.push(value);
    },
    delAllkindImg(delPic) {
      this.imgArrAllkind.splice(delPic.index, 1);
    },
    saveLicenseImg(value) {
      this.imgArrlicense.push(value);
    },
    delLicenseImg(delPic) {
      this.imgArrlicense.splice(delPic.index, 1);
    },
    delPic(data) {
      this.imgArr.splice(data.index, 1);
    },
    // 添加图片 触发上传图片按钮
    addHeadpic() {
      this.clickUpload = "head";
      let oInput = document.getElementById("uploads");
      console.log("head", oInput);
      oInput.click();
    },
    // addZhizhao () {
    //   this.clickUpload = 'zhizhao'
    //   this.fixedNum = [18,23]
    //   let zhizhao = document.getElementById("zhizhao");
    //   zhizhao.click();
    // },
    // 选择文件 触发
    uploadImg(selectFileEvent) {
      console.log(selectFileEvent);
      this.isClick++;
      this.isClickE = selectFileEvent;
    },
    editorContent(data) {
      this.qiye.jianjie = data;
    },
    // selectService (index) {
    //   this.serviceType[index].isSelect = !this.serviceType[index].isSelect
    // },
    // addLabel () {
    //   this.$emit('addLabel')
    // },
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val) {
      this.zuobiao = val;
      console.log("-------qiyeBIanji----------");
      this.didian = val.label;
      this.coordinate = val.value;
      this.showmap();
    },
    async submit() {
      var qy = this.qiye;
      if (!this.didian) {
        this.$emit("closeLoading");
        return this.$Modal.warning({
          title: "提示",
          content: "请填写经营地址"
        });
      }
      for (let key in this.rules) {
        if (!qy[key]) {
          this.$emit("closeLoading");
          return this.$Modal.warning({
            content: this.rules[key][0].message,
            title: "提示"
          });
        }
      }

      if (!that.qiye.name) {
        this.$Message.warning("请填写企业名称");
        this.$emit("closeLoading");
        return;
      }
      var url = this.urlobj.addQy;

      //处理附件id
      var fujianId = this.imgArr.map(item => {
        return item.id;
      });
      var licensePicUrl = this.imgArrlicense.map(item => {
        return item.path;
      });
      let lPicUrl = "";
      licensePicUrl.forEach(item => {
        lPicUrl += item + ",";
      });
      lPicUrl = lPicUrl.substring(0, lPicUrl.lastIndexOf(","));

      // 各类许可证明
      var companyProveUrl = this.imgArrAllkind.map(item => {
        return item.path;
      });
      let aPicUrl = "";
      companyProveUrl.forEach(item => {
        aPicUrl += item + ",";
      });
      aPicUrl = aPicUrl.substring(0, aPicUrl.lastIndexOf(","));
      // 各类许可证明结束

      var promisePicUrl = this.imgArrPromise.map(item => {
        return item.path;
      });
      if (!lPicUrl) {
        this.$emit("closeLoading");
        return this.$Modal.warning({
          title: "提示",
          content: "请上传营业执照"
        });
      }

      let pPicUrl = "";
      promisePicUrl.forEach(item => {
        pPicUrl += item + ",";
      });
      pPicUrl = pPicUrl.substring(0, pPicUrl.lastIndexOf(","));
      var healthyPicUrl = this.imgArrHealthy.map(item => {
        return item.path;
      });
      let hPicUrl = "";
      healthyPicUrl.forEach(item => {
        hPicUrl += item + ",";
      });
      hPicUrl = hPicUrl.substring(0, hPicUrl.lastIndexOf(","));

      var coordinate = "";
      if (that.zuobiao.value) {
        var zuobiao = that.zuobiao.value.split(",");
        var a = {
          x: zuobiao[0],
          y: zuobiao[1]
        };
        coordinate = '{"x":"' + zuobiao[0] + '","y":"' + zuobiao[1] + '"}';
        console.log(coordinate);
      }
      this.$post(url, {
        companyName: qy.name, //企业名称,
        companyAlias: qy.alias, //企业别名
        id: that.companyId, //企业ID传值代表修改,
        communityId: this.communityId, //所属行政区域，不传代表当前登录系统,
        address: that.didian ? that.zuobiao.label : "", //地址,
        coordinate: that.didian ? coordinate : "", //地址坐标JSON格式,
        headPicUrl: qy.headPic && qy.headPic[0].path, //企业头像图片URL,
        remark: qy.jianjie, //企业简介
        registrationNO: qy.zhuceNum, //企业注册号
        tradeId: qy.tradeId, // 行业类别id
        deptId: qy.deptId, // 所在分局id
        legal: qy.farenName, //企业法人
        legalPhoneNO: qy.farenTel, //法人电话
        manager: qy.zerenName, //负责人
        managerPhoneNO: qy.zerenTel, //责任人电话
        timeList: qy.timeList, //经营时间
        featureId: that.xingzhi, //企业性质id
        attrIdList: that.selectRadio, //企业属性ID,
        typeIdList: that.selectType, //企业类型ID集合,
        attachmentIdList: fujianId, //企业附件ID集合,
        serviceIdList: that.serviceIdList, //服务类型Id集合,
        acreage: parseFloat(qy.area), //企业面积
        canDelivery: qy.paisong == "是" ? 1 : 0, //是否可派送
        deliveryTimeList: qy.paisongTime, //派送时间
        businessScope: qy.businessScope, //经营范围
        employeeNum: qy.employeeNum, //职工人数
        licensePicUrl: lPicUrl, // 营业执照
        promisePicUrl: pPicUrl, // 承诺书
        healthyPicUrl: hPicUrl, // 健康证明
        companyProveUrl: aPicUrl, // 各类许可证明
        companyType: qy.companyType == "企业" ? 0 : 1 //企业类型
      })
        .then(res => {
          if (res.isSucceed) {
            that.$Message.success("修改成功");
            that.$emit("successBianji", 1);
          } else {
            this.$emit("closeLoading");
          }
        })
        .catch(e => {
          this.$emit("closeLoading");
        });
    },
    initData() {
      var data = this.qiye;
      console.log(data);
      console.log(this.qiye.companyType);
      this.selectType = data.qyType.map(item => {
        return item.id;
      });
      this.serviceIdList = data.serviceType.map(item => {
        return item.id;
      });
      this.didian = data.zuobiao.label;
      this.zuobiao = data.zuobiao;
      this.xingzhi = data.xingzhi.id;
      // if (!data.qyNature.length) {
      //   this.selectRadio =
      // }
      console.log(this.qyNature);
      this.selectRadio = data.qyNature.map(item => {
        return item.id;
      });
      this.imgArr = data.imgArr;

      data.licensePicArr &&
        data.licensePicArr.forEach((item, index) => {
          let obj = {
            path: item,
            id: index
          };
          this.imgArrlicense.push(obj);
        });
      data.allKindPicArr &&
        data.allKindPicArr.forEach((item, index) => {
          let obj = {
            path: item,
            id: index
          };
          this.imgArrAllkind.push(obj);
        });
      data.promisePicArr &&
        data.promisePicArr.forEach((item, index) => {
          let obj = {
            path: item,
            id: index
          };
          this.imgArrPromise.push(obj);
        });
      data.healthyPicArr &&
        data.healthyPicArr.forEach((item, index) => {
          let obj = {
            path: item,
            id: index
          };
          this.imgArrHealthy.push(obj);
        });
      this.modelSelect = data.community ? data.community.id : "";
    },
    selectCommunity(obj) {
      var communityId = obj;
      this.serviceIdList = [];
      this.communityId = communityId;
      this.getQyType();
      this.getServiceType();
      this.getIndustryList();
      this.getDepList();
      this.getQyAttr();
      this.getQyFeature();
    },
    //获取企业类型
    getQyType() {
      var url = this.urlobj.getQiyeType;
      this.$get(url, {
        communityId: this.communityId,
        type: "type"
      }).then(res => {
        this.qyType = res.rows.map(item => {
          return {
            id: item.id,
            name: item.title
          };
        });
      });
    },
    //获取行业类别
    getIndustryList() {
      let url = this.urlobj.getIndustryCategory;
      this.$get(url).then(res => {
        this.IndustryType = res.rows.map(item => {
          return {
            id: item.id,
            name: item.dicName
          };
        });
      });
    },
    //获取所在分局
    getDepList() {
      var url = this.urlobj.getDepList;
      this.$post(url, {
        communityId: this.communityId
      }).then(res => {
        this.depType = res.rows.map(item => {
          return {
            id: item.id,
            name: item.deptName
          };
        });
      });
    },
    //获取服务类型
    getServiceType() {
      var url = this.urlobj.getQiyeType;
      this.$get(url, {
        communityId: this.communityId,
        type: "service"
      }).then(res => {
        var serviceList = [];
        res.rows.forEach(item => {
          if (item.children.length > 0) {
            item.children.forEach(_item => {
              serviceList.push({
                name: _item.title,
                id: _item.id
              });
            });
          } else {
            serviceList.push({
              name: item.title,
              id: item.id
            });
          }
        });
        this.serviceType = serviceList;
      });
    },
    //获取企业属性
    getQyAttr() {
      var url = this.urlobj.getQiyeType;
      this.$get(url, {
        communityId: this.communityId,
        type: "attr"
      }).then(res => {
        this.qyNature = res.rows.map(item => {
          return {
            id: item.id,
            name: item.title
          };
        });
        if (!this.qiye.qyNature.length) {
          this.selectRadio = [this.qyNature[1].id];
          console.log(this.selectRadio);
        }
      });
    },
    // 获取企业性质
    getQyFeature() {
      var url = this.urlobj.getQiyeType;
      this.$get(url, {
        communityId: this.communityId,
        type: "feature"
      }).then(res => {
        this.qiyeXingzhi = res.rows.map(item => {
          return {
            id: item.id,
            name: item.title
          };
        });
      });
    },
    addTime() {
      this.qiye.timeList.push({
        beginTime: "",
        endTime: ""
      });
    },
    addPaisongTime() {
      this.qiye.paisongTime.push({
        beginTime: "",
        endTime: ""
      });
    },
    delTime(index) {
      this.qiye.timeList.splice(index, 1);
    },
    delPaisongTime(index) {
      this.qiye.paisongTime.splice(index, 1);
    }
  },
  created() {
    this.getIndustryList();
    this.getDepList();
  },
  mounted() {
    that = this;
    this.qiye = this.oldQiye;
    this.initData();
    document.addEventListener("click", that.add);
    this.getQyType();
    this.getServiceType();
    this.getQyAttr();
    this.getQyFeature();
  },
  beforeDestroy() {
    document.removeEventListener("click", that.add);
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item-error .ivu-input {
  border-color: #dcdee2;
}
/deep/ .ivu-form-item-error .ivu-select-selection {
  border-color: #dcdee2;
}
.row-wrap {
  margin-bottom: 50px;
}

/deep/ .card .ivu-radio-wrapper {
  font-size: 14px;
}
.left {
  text-align: right;
  margin-right: 20px;
  width: 64px;
  position: relative;
  .require {
    position: absolute;
    left: -10px;
    color: red;
  }
}

.card {
  width: 97%;
}

.title {
  padding: 20px 0 0 20px;
  text-align: left;
}

.info-wrapper {
  padding-bottom: 30px;
  border-bottom: 1px solid #dddddd;
}

.mar-btm10 {
  margin-bottom: 10px;
}

.mar-btm20 {
  margin-bottom: 20px;
}

.mar-btm30 {
  margin-bottom: 30px;
  /* align-items: center; */
}

.mar-btm30:last-child {
  margin-bottom: 0;
}

.pad-btm30 {
  padding-bottom: 30px;
}

.text1 {
  font-size: 20px;
  color: #333;
  padding-right: 10px;
  font-weight: 600;
}

.text2 {
  font-size: 14px;
  color: #999;
  margin-left: 20px;
}

.text3 {
  font-size: 11px;
  color: #666;
}

.text4 {
  font-size: 14px;
  color: #999;
  margin: 0 20px;
}

.xing {
  color: red;
  padding-left: 5px;
}

.info {
  font-size: 16px;
  color: #333;
  padding-left: 20px;
}

.yuan {
  width: 100px;
  height: 100px;
  border-radius: 100%;
}

.head-pic-wrapper {
  position: relative;
  margin-left: 20px;
}

.head-pic-icon {
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  background: #efefef;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  width: 52.36%;
}

.img_add {
  color: #bbbbbb;
  border: 1px solid #bbb;
  text-align: center;
  line-height: 75px;
  height: 100px;
  width: 100px;
  position: relative;
  padding-top: 10px;
  margin-bottom: 20px;
}

.service-item-wrapper {
  position: relative;
  border: 1px solid #dedede;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  color: #999;
  font-size: 14px;
  border-radius: 5px;
  margin-right: 20px;
  align-items: center;
}

.icon-wrapper {
  height: 20px;
  width: 20px;
  border-radius: 100%;
  margin-right: 10px;
}

.icon {
  color: #fff;
  font-size: 19px;
  margin-top: -4px;
  margin-left: 1px;
}

.icon1 {
  color: #fff;
  font-size: 14px;
  margin-top: -4px;
  margin-left: 3px;
}

.icon2 {
  color: #ccc;
  font-size: 14px;
}

.select-pic {
  position: absolute;
  width: 15px;
  top: -8px;
  right: -8px;
}

.yingyezhizhao {
  position: absolute;
  margin-bottom: 30px;
  left: 50%;
  top: 20px;
}

.zhizhao-wrapper {
  padding-left: 60px;
  align-items: center;
}

#container {
  width: 52%;
  height: 300px;
  position: absolute;
  z-index: 999;
  top: 36px;
  left: 28.5%;
}

.checkbox-item {
  margin-right: 16px;
  margin-bottom: 10px;
  color: #999;
}

.addBtn {
  width: 70px;
  height: 26px;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background: #fff;
  border: 1px solid #ff7b44;
  color: #ff7b44;
  border-radius: 4px;
  font-size: 14px;
}

.addBtn .iconfont {
  color: #ff824e;
  margin-right: 5px;
  margin-bottom: 3px;
  font-size: 14px;
}

.time-wrapper {
  align-items: center;
  width: 73%;
  margin-bottom: 10px;
}

.del-icon {
  align-self: center;
  color: #d22b2b;
  margin-left: 30px;
  font-size: 24px;
}

/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
}

.address_nodata {
  color: #bbb;
}

.address:hover {
  border: 1px solid #ff7b44;
}

.address:active {
  border: 1px solid #ff7b44;
}
.require {
  position: relative;
}
</style>
